// extracted by mini-css-extract-plugin
export default {"output":"_10LQ3"};